export default __webpack_public_path__ + "static/media/bottom-background.aa6af940.png";